import React                from 'react';
import { browserHistory }   from 'react-router';
import CoverButtons         from '../Fields/CoverButtons';
import FieldError           from '../Fragments/FieldError';
import CompareProductsModal from '../Modals/CompareProducts';

let HttpService = require('../Managers/HttpService');
let Quote = require('../Managers/Quote');
let FaCross = require('react-icons/lib/fa/close');

const Config = HttpService.getConfigForHost();

const ProductCovers = React.createClass({
    propTypes: {
        reloadStep: React.PropTypes.func.isRequired,
        callBackRiskCheck: React.PropTypes.func,
    },

    getInitialState() {
        return {
            isChecked: false,
            productCovers: [],
            hasQuote: Quote.hasQuote(),
            hasAcceptedNewProductTerms: false,
            isNewProductModalVisible: false,
        };
    },

    componentWillMount() {
        let _self = this;
        this.coversRequest = $.ajax({
            type: 'POST',
            url: Config.api.products.url
        }).done(function(result) {

            if (result.data.length > 0) {
                _self.setState({ productCovers: result.data });
            } else {
                browserHistory.push('/error/no-product-covers-empty-data-array');
            }
        }).fail(function(e){
            JSON.Stringify(e);
            browserHistory.push('/error/couldnt-load-product-covers');
        });
    },

    componentWillUnmount() {
        this.coversRequest.abort();
    },

    openNewProductWarningModal() {
        this.setState({ isNewProductModalVisible: true });
    },

    closeNewProductWarningModal() {
        this.setState({ isNewProductModalVisible: false });
    },

    acceptNewProductTerms() {
        this.setState({
            hasAcceptedNewProductTerms: true,
            isNewProductModalVisible: false,
        });
     
        window.localStorage.setItem('product_has_changed', true);
        this.clearAnswers();
    },

    doValidation() {
       
       // window.localStorage.setItem('Cover_Flood', 'no');
       
        localStorage.getItem('flood_risk') == "MEDIUM";
        this.setState({
            pafResults: false,
            pafLookupPostcode: false,
            activeValue: false
        });
        
       
        this.setState({
            pafResults: true,
            pafLookupPostcode: true,
            activeValue: true
        });
        Quote.set(this.props.fieldNamePrefix + '_address_line1', '');
        Quote.set(this.props.fieldNamePrefix + '_address_line2', '');
        Quote.set(this.props.fieldNamePrefix + '_address_line3', '');
        Quote.set(this.props.fieldNamePrefix + '_address_postcode', '');
      
        
        let jpk = window.localStorage.getItem('jpk');
        const elements = document.getElementsByClassName('address-selection');
    
        // Loop through all elements with the class name 'hideMe'
        for (let i = 0; i < elements.length; i++) {
            // Hide each element by setting its display property to 'none'
            elements[i].style.display = 'none';
        }

        if (jpk == null || jpk == '') {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        this.setState({
            hasError : false,
            errors : [],
        });
        return true;
    },
    checkvalidationform(){
       let contactlength= $('#contact').val().length;
       if($('#firstname').val()!="" && $('#lastname').val()!="" && $('#email').val()!="" &&$('#contact').val()!="" ){
       
        $('#formerror').hide();
       
       }else
       {
     
        $('#formerror').show();


        
       }

       if( $('#contact').val()!="" && contactlength <=10 ){
        $('#digitvalidation').show();
       }else{
        $('#digitvalidation').hide();
       }
    },
    /**
     * Pulls out 'your details' questions and answers, stashes them in a
     * temporary array, clears the local storage and then pushes the array
     * values back to local storage.
     */
    clearAnswers() {
        let answers = JSON.parse(window.localStorage.getItem('answers'));
        let tempAnswers = [];

        // Loop through the answers we already have
        answers.map(function(a) {
            switch (a.question) {
                case 'email_address':
                case 'myhomelet_email':
                case 'is_logged_into_myhomelet':
                case 'title':
                case 'other_title':
                case 'first_name':
                case 'last_name':
                case 'date_of_birth_at':
                case 'phone_number':
                case 'is_cor_address_uk':
                case 'cor_address_line1':
                case 'cor_address_line2':
                case 'cor_address_line3':
                case 'cor':
                    tempAnswers.push(a);
                break;
            }
        });

        // Remove local storage items
        window.localStorage.removeItem('quote');
        window.localStorage.removeItem('questions_cache');
        window.localStorage.removeItem('jpk');
        window.localStorage.removeItem('spk');

        // Push in the 'new' answers
        window.localStorage.setItem('answers', JSON.stringify(tempAnswers));

        // Empty the array so it never has a chance of doubling up
        tempAnswers = [];

        this.props.reloadStep();
    },

    render() {
        return(
            <div className="product-covers">
                <question-row class="fixed unpadded no-border">
                    <h1>Landlord Insurance Quote</h1>
                    <h2 className="product-selection-title">About your cover</h2>
                </question-row>
                {!this.state.hasQuote || this.state.hasAcceptedNewProductTerms === true ?
                    <div>
                        <question-row class="no-border fixed">
                            <label className="label-product-cover">Please select your type of cover</label>
                            <CoverButtons
                                covers={this.state.productCovers}
                                callBackRiskCheck={this.props.callBackRiskCheck}
                                setActiveCallback={() => {
                                    this.doValidation();
                                }}
                            />
                        </question-row>
                        <div className="clearfix" />
                        <question-row class="no-border unpadded">
                            <div className="question-main">
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                                <CompareProductsModal />
                            </div>
                        </question-row>
                        <question-row class="unpadded fixed">
                        
                        
                        <table className="table email table-striped table-responsive "> 
   
   <tbody>
<tr>
<td colSpan="2"> 
<h2>A little about you</h2> 
</td>
</tr>

<tr >
<td className="tablewidth">Your first name</td>
<td>    
<input className="pad" id="firstname" type="text"  placeholder="Your first name" name="firstname" onChange={this.checkvalidationform} />

</td>
</tr>
<tr>
<td className="tablewidth">Your last name</td>
<td>    
<input className="pad" id="lastname" type="text"  placeholder="Your last name" name="lastname" onChange={this.checkvalidationform} />

</td>

</tr>
<tr>
<td className="tablewidth">Your email</td>
<td>   
<input className="pad"  id="email" type="text"  placeholder="Your email address" name="email" onChange={this.checkvalidationform}/>

</td>

</tr>
<tr>
<td className="tablewidth">Your telephone</td>
<td>    
<input className="pad"  id="contact" type="number"  placeholder="Your telephone number" name="contact" onChange={this.checkvalidationform}/>

</td>

</tr>
<tr>
<td colSpan="2">

{/* <div id="formerror" class="alert alert-primary" role="alert" >
  Please Enter all Your Contact Information details
</div> */}
<div  id="formerror" className="error-container error-right"><div className="error"><div className="arrow"></div><div className="error-content"><ul className="list-unstyled"><li>Please provide all your contact details</li></ul></div></div></div>
<div  id="digitvalidation" className="error-container error-right"><div className="error"><div className="arrow"></div><div className="error-content"><ul className="list-unstyled"><li>Your phone number must be more than 10 digits long.</li></ul></div></div></div>


{/* <div id="formerror" class="error-container error-right"><div class="error"><div class="arrow"></div><div class="error-content"><ul class="list-unstyled"><li> Please Enter all Your Contact Information details</li></ul></div></div></div> */}
</td>
</tr>

</tbody>
</table>       
                            
                        </question-row>




                    </div>
                :
                    <div>
                        <question-row class="no-border unpadded">
                            <div className="question-main">
                                <p>You can update your product selection by clicking the link below. Just to let you know, if you do change the product selection you&rsquo;ll need to answer questions about your property again and may be asked some additional questions for your new quotation.</p>
                                <p><a className="underline" onClick={this.openNewProductWarningModal}>Change product selection</a></p>
                                <modal-container class={this.state.isNewProductModalVisible ? 'modal-active' : null}>
                                    <modal className="has-footer alert small-width">
                                        <div className="modal-header">
                                            Change Selected Product
                                            <a className="close-cross" onClick={this.closeNewProductWarningModal}><FaCross /></a>
                                        </div>
                                        <div className="modal-body">
                                            By continuing, you will lose all of the answers you have previously provided, <b>apart from</b> your personal details on the 'About You' step of the journey.
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-success text--transform-uppercase" onClick={this.acceptNewProductTerms}>I Understand</button>
                                            <button className="btn btn-default pull-right" onClick={this.closeNewProductWarningModal}>Cancel</button>
                                        </div>
                                    </modal>
                                </modal-container>
                            </div>
                        </question-row>
                    </div>
                }
            </div>
        );
    }

});
export default ProductCovers;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/ProductCovers.js
 **/